import { Component, OnInit,Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";

export interface DialogData {
  user_id: string;
  manageData: any;
}

@Component({
  selector: 'app-guest-email',
  templateUrl: './guest-email.component.html',
  styleUrls: ['./guest-email.component.css']
})
export class GuestEmailComponent implements OnInit {

  clientGuestEmail: FormGroup;
  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<GuestEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService
    ) { }

  ngOnInit() {
    this.clientGuestEmail = this.formBuilder.group({
      guest_email: [null, [Validators.required, Validators.email]]
    });
    if (this.data.manageData) {
      this.clientGuestEmail.setValue({
        'guest_email': this.data.manageData.guest_email
      });
    }
  }
  isFieldValid(field: string) {
    return (
      !this.clientGuestEmail.get(field).valid &&
      this.clientGuestEmail.get(field).touched
    );
  }
  onSubmit(postData) {
    this.dialogRef.close(postData);
  }

  onNoClick(): void {   
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/guest-email/guest-email.component.ts